import { Fixture } from '@cds/betting-offer';
import { DetailedFixtureFactory, FixtureFactory } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { OfferGroupingService } from '@frontend/sports/betting-offer/feature/offer-grouping';
import { GridEvent } from '@frontend/sports/grid/core/feature/model';
import { Observable, map, of } from 'rxjs';

import { BaseFactory, EventOption, GridSourceEvent } from './event.factory';

export class GridFixtureFactory implements BaseFactory {
    constructor(
        private fixtureFactory: FixtureFactory,
        private detailedFactory: DetailedFixtureFactory,
        private grouping: OfferGroupingService,
    ) {}

    canCreate(events: GridSourceEvent[]): boolean {
        return 'games' in events[0] || 'optionMarkets' in events[0];
    }

    create(events: GridSourceEvent[], options?: EventOption): Observable<GridEvent[]> {
        const fixtures = events as Fixture[];

        if (!options?.marketGrouping) {
            return of(fixtures.map((fixture) => this.fixtureFactory.create(fixture)));
        }

        return this.grouping.getFixtureGrouping(fixtures[0].sport.id, 'any').pipe(
            map((groupingConfiguration) =>
                fixtures.map((fixture) => {
                    if (!groupingConfiguration) {
                        throw new Error('Could not map events without grouping');
                    }

                    return this.detailedFactory.create({
                        fixture,
                        splitFixtures: [],
                        grouping: groupingConfiguration,
                        isPriceBoosted: options.isPriceBoosted,
                        excludePriceboostedMarketGrouping: options.excludePriceboostedMarketGrouping,
                    });
                }),
            ),
        );
    }
}
